"use strict";

const openEyes = function () {
    const self = $(this);
    self.parent().find('input').prop('type', 'text');
    self.parent().find('.input-eye-btn').addClass('open-eyes');
}

const closeEyes = function () {
    const self = $(this);
    self.parent().find('input').prop('type', 'password');
    self.parent().find('.input-eye-btn').removeClass('open-eyes');
}

const focusEyes = function () {
    const self = $(this);
    self.parent().find('.input-eye-btn').addClass('on-focus');
}

const blurEyes = function () {
    const self = $(this);
    self.parent().find('.input-eye-btn').removeClass('on-focus');
}

$(function () {
    $(".input-eye-btn").on('mousedown touchstart', openEyes);
    $(".input-eye-btn").on('mouseup mouseout touchcancel touchend touchmove', closeEyes);
    $("input").on('focus', focusEyes);
    $("input").on('blur', blurEyes);
});
